import * as React from "react";
import AbstractLookup, { LookupConfigInterface } from "./AbstractLookup";
import { LookupInterface } from "./LookupInterface";
import * as onClickOutside from "react-onclickoutside";
import Translator from "../../../Translation/Translator";
import Constants from "../../../Action/Constants";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { None } from "../../../Entity/Entities/Person/Role/Roles/None";
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';

class PersonLookup extends AbstractLookup implements LookupInterface {
  protected filterByCompanyId: number = 0;
  protected componentRef: any;
  protected config: LookupConfigInterface = {
    entities: this.props.app.persons,
    type: Constants.LOOKUP_COMPONENT_PERSON_CREATE_START,
    payloadPrefix: "person",
    entityTranslation: Translator.trans("dropdown-person-label"),
    disableEntityCreation: this.props.disableEntityCreation || false,
    floatingLabelText: this.props.floatingLabelText || Translator.trans("dropdown-selectperson-label"),
    labelText: this.props.labelText ? this.props.labelText : Translator.trans("dropdown-person-label"),
    buttonLabel: this.props.buttonLabel || Translator.trans("dropdown/person-button/newperson"),
    dialogTitle: this.props.dialogTitle || Translator.trans("dropdown/person-button/newperson"),
     dialogType: this.props.dialogType || Constants.LOOKUP_COMPONENT_DIALOG_TYPE_SMALL,
    visibilityProperty: "displayName",
    dialogInputToComponentSyncProperty: "firstName",
    componentState: {
      firstName: "",
      lastName: "",
      dateOfBirth: null,
      identityNumber: "",
      identityType: 255,
      address: {},
      contactRoleId: this.props.contactRoleId || None.contactRoleId
    },
    filter: this.props.filter || false,
    createPage: this.props.templateFor ? `/app/${this.props.templateFor}/create` : "/app/person/create",
    linkedObjectUrl: this.props.templateFor ? `/app/${this.props.templateFor}/update/` : "/app/person/update/",
    noResultText: this.props.noResultText || this.trans("dropdown-person-notfound")
  };

  constructor(public props) {
    super(props);
  }

  public syncDialogValue(value: string): any {
    this.config.componentState.firstName = value;
    this.setState({
      firstName: value
    });
  }

  public deUmlaut(value){
    if (!value) {
      return "";
    }

    value = value.toLowerCase();
    value = value.replace(/ä/g, 'a');
    value = value.replace(/ö/g, 'o');
    value = value.replace(/ü/g, 'u');
    value = value.replace(/ß/g, 'ss');
    value = value.replace(/ /g, '-');
    value = value.replace(/\./g, '');
    value = value.replace(/,/g, '');
    value = value.replace(/\(/g, '');
    value = value.replace(/\)/g, '');

    return value;
  }

  public getList(): any[] {
    let list: PersonInterface[] = this.getEntities()
      .filter((person: PersonInterface) => {
        if ((!this.props.includeUsers && !this.props.onlyUsers) && (person.isAdmin() || person.isUser())) {
          return false;
        }

        return true;
      })
      .filter((person: PersonInterface) => {
        if (!!person && person.displayName && person.displayName.toLowerCase() && person.displayName.toLowerCase().includes(this.state.searchText && this.state.searchText.toLowerCase()) === true) {

          return true;
        } else {
          if (this.deUmlaut(person.displayName).toLowerCase().includes(this.state.searchText && this.state.searchText.toLowerCase()) === true) {
            return true;
          } else {
            let stringArr = this.state.searchText && this.state.searchText.toLocaleLowerCase().split(" ") || [];
            stringArr = stringArr.map((string, index) => {
              if (index !== stringArr.length - 1) {
                return string + " ";
              }

              else {
                return string;
              };
            });

            let isIncluded = true;

            stringArr.forEach(string => {
              if (!(person.displayName && (person.displayName.toLowerCase() + " ").includes(string))) {
                isIncluded = false;
              }
            })

            if (isIncluded) {

              return true;
            } else {
              let isIncluded = true;

              stringArr.forEach(string => {
                if (!((this.deUmlaut(person.displayName).toLowerCase() + " ").includes(string))) {
                  isIncluded = false;
                }
              })

              if (isIncluded) {

                return true;
              }
            }
          }
        }
      })
      .sort((person1: PersonInterface, person2: PersonInterface) => {
        if (`${person1.firstName.toLowerCase()} ${person1.lastName.toLowerCase()}` > `${person2.firstName.toLowerCase()} ${person2.lastName.toLowerCase()}`) {
          return 1;
        }

        if (`${person1.firstName.toLowerCase()} ${person1.lastName.toLowerCase()}` < `${person2.firstName.toLowerCase()} ${person2.lastName.toLowerCase()}`) {
          return -1;
        }

        return  0;
      });
      
    if (this.props.filterByCompanyId) {
      list = list.filter((person: PersonInterface) => {
        return person.companyId === this.props.filterByCompanyId;
      });
    }

    if (this.props.onlyUsers) {
      list = list.filter((person: PersonInterface) => {
        return (person.isAdmin() || person.isUser());
      });
    }

    if (Array.isArray(this.props.filterOutEntities) === true) {
      list = list.filter((person: PersonInterface) => {
        return this.props.filterOutEntities.map(person => person.selectedPerson ? person.selectedPerson.id : person.id).indexOf(person.id) === -1;
      });
    }

    return list.map((person: PersonInterface, index: number) => {
      return (
        <ListItem
          key={index}
          onMouseDown={this.onSelect.bind(this, person)}
        >
          <ListItemAvatar>
            <Avatar className="avatar">
              {person.renderAvatar()}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={person.displayName}
            secondary={
              <span>
                <span style={{display: "inline-block", marginRight: "10px"}}>{person && person.roleDisplayName()}</span>
                <span>{person.email}</span>
              </span>}
          />
        </ListItem>
      );
    });
  }

  public getEntities(): PersonInterface[] {
    if (Array.isArray(this.props.entitiesToSearch)) {
      return this.props.entitiesToSearch;
    } else {
      return this.props.entities || this.props.app.persons.filter(person => !!person)
        .filter((person: PersonInterface) => {
          return person.removed === false || (person.removed === true && !!this.props.autoSelectId && person.id === this.props.autoSelectId);
        });
    }
  }

  public getPayloadFromComponent(): any {
    return this.componentRef.getWrappedInstance().getPayload();
  }
}

export default onClickOutside(PersonLookup);
